import { useState, useEffect } from "react";
import { useGetAllSyllabusQuery } from "src/services/SyllabusService";

const useSyllabus = () => {
    const [syllabus, setSyllabus] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllSyllabusQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setSyllabus(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { syllabus, isDataLoading };
};

export default useSyllabus;
